import React from 'react';
import Skeleton from '@/components/ui/Skeleton/Skeleton';
import CardSkeleton from './QuestionCards/CardSkeleton';
import HeaderSkeleton from './HeaderSkeleton';

const QuestionGradingSkeleton = () => (
  <>
    <div className="tw-py-4">
      <Skeleton height="tw-h-8" width="tw-w-96" />
    </div>
    <HeaderSkeleton />
    <CardSkeleton />
    <hr className="tw-mx-[-20px] tw-text-med-grey" />
    <div className="tw-pb-4">
      <Skeleton height="tw-h-5" width="tw-w-40" />
    </div>
    <CardSkeleton />
    <CardSkeleton />
    <CardSkeleton />
  </>
);

export default QuestionGradingSkeleton;
